import { Component, EventEmitter } from '@angular/core';
import { formatearFecha } from 'src/app/components/utils/formato-fecha.componente';



export enum TabDictionariMarkePlace {
  STAFFING   = "Staffing",
  SUMMARIZES = "Summarizes",
}


@Component({
  selector: 'app-marketplace',
  templateUrl: './marketplace.component.html',
  styleUrls: ['./marketplace.component.css']
})
export class MarketplaceComponent {
  //Variables
  tittle = "Hola "  + JSON.parse(sessionStorage.getItem('userCurrentGraph') || '{}').displayName;
  fecha: any;
  protected currentUser: any;

  ngOnInit() {
    this.mostrarHora();
    this.currentUser = JSON.parse(sessionStorage.getItem('userCurrentGraph') || '{}');
  }


  mostrarHora() {
    this.fecha = formatearFecha(new Date());
    setInterval(() => {
      this.fecha = formatearFecha(new Date());
    }, 1000);
  }


  public nameTab = TabDictionariMarkePlace.STAFFING;
  public tabListItems: { name: string; status: string; id: number; }[] = [
    {
      name: "Demanda",
      status: "active",
      id: 1
    },
    {
      name: "Capacidad",
      id: 2,
      status: "unactive"
    },
    {
      name: "Resumen",
      id: 3,
      status: "unactive"
    },
  ]

  public tabSelected: EventEmitter<{ name: string,id:number, status: string }> = new EventEmitter<{ name: string,id:number, status: string }>


  public onSelectItemTab(tabDictionariMarkePlace: TabDictionariMarkePlace){
    this.nameTab = tabDictionariMarkePlace;
  }

  public get TabDictionariMarkePlace(): typeof TabDictionariMarkePlace {
    return TabDictionariMarkePlace; 
  }

}
